import React from 'react';
import { BookOpen, Check } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PriceDisplay } from './PriceDisplay';
export function ValueSummary() {
  const items = [{
    name: 'La Biblia de los Condimentos Caseros — 200+ págs, 60+ recetas',
    value: 97000,
    isMain: true
  }, {
    name: 'Bono #1 — Mi Primer Condimento en 24h',
    value: 46000
  }, {
    name: 'Bono #2 — Kit Venta Lista (Etiquetas + Scripts)',
    value: 65000
  }, {
    name: 'Bono #3 — Guía Vender Sin Vergüenza',
    value: 36000
  }, {
    name: 'Bono #4 — Condimentos Express 20 Min',
    value: 46000
  }, {
    name: 'Bono #5 — Calculadora Anti-Inflación',
    value: 46000
  }, {
    name: 'Bono #6 — Guía de Condimentos Italianos',
    value: 56000
  }, {
    name: 'Bono #7 — Salsas Gourmet para Vender',
    value: 65000
  }, {
    name: 'Bono #8 — Actualizaciones de Por Vida',
    value: 'Infinito' as string | number
  }];
  return <section className="py-8 md:py-20 px-4 bg-white border-t border-gray-100" data-id="element-223">
      <div className="max-w-3xl mx-auto" data-id="element-224">
        <h2 className="text-3xl md:text-5xl font-black text-center mb-8 md:mb-12 text-gray-900" data-id="element-225">
          Resumen de Todo Lo Que Recibís Hoy
        </h2>

        <div className="bg-spice-50 rounded-3xl p-4 md:p-10 border-2 border-spice-200 shadow-xl" data-id="element-226">
          <div className="flex justify-center mb-4 md:mb-8" data-id="element-227">
            <div className="w-16 h-16 md:w-24 md:h-24 bg-white rounded-2xl shadow-sm border border-spice-100 flex items-center justify-center" data-id="element-228">
              <BookOpen className="w-8 h-8 md:w-12 md:h-12 text-spice-500" data-id="element-229" />
            </div>
          </div>

          <div className="space-y-1.5 md:space-y-4 mb-4 md:mb-8" data-id="element-230">
            {items.map((item, i) => <div key={i} className={`flex justify-between items-center p-2 md:p-3 rounded-lg ${item.isMain ? 'bg-spice-200/50 font-bold' : 'hover:bg-white'}`} data-id="element-231">
                <div className="flex items-center" data-id="element-232">
                  <Check className="w-5 h-5 text-success-500 mr-3 flex-shrink-0" data-id="element-233" />
                  <span className="text-gray-800 text-sm md:text-base" data-id="element-234">
                    {item.name}
                  </span>
                </div>
                <span className="text-gray-600 line-through text-sm md:text-base whitespace-nowrap ml-4" data-id="element-235">
                  {typeof item.value === 'number' ? <PriceDisplay amountArs={item.value} data-id="element-236" /> : item.value}
                </span>
              </div>)}
          </div>

          <div className="border-t-2 border-dashed border-spice-300 pt-4 md:pt-6 mb-4 md:mb-6 text-center" data-id="element-237">
            <p className="text-gray-600 font-medium mb-2" data-id="element-238">VALOR TOTAL</p>
            <p className="text-3xl text-gray-400 line-through decoration-urgency-500 decoration-2 mb-6" data-id="element-239">
              <PriceDisplay amountArs={552000} data-id="element-240" />
            </p>

            <p className="text-xl font-bold text-spice-700 mb-2" data-id="element-241">
              Hoy lo obtenés TODO por solo
            </p>
            <p className="text-5xl md:text-7xl font-black text-gray-900 mb-5 md:mb-8" data-id="element-242">
              <PriceDisplay amountArs={18997} data-id="element-243" />
            </p>

            <CtaButton text="AGREGAR AL CARRITO »" className="w-full md:w-auto md:px-12" scrollTo="oferta" data-id="element-244" />

            <p className="text-sm text-gray-600 mt-4 flex items-center justify-center space-x-2" data-id="element-245">
              <span data-id="element-246">Acceso inmediato</span>
              <span data-id="element-247">•</span>
              <span data-id="element-248">Pago único</span>
              <span data-id="element-249">•</span>
              <span data-id="element-250">Garantía 30 días</span>
            </p>
          </div>

          <p className="text-center text-xs text-gray-500" data-id="element-251">
            Me reservo el derecho de cerrar esta oferta sin previo aviso.
          </p>
        </div>
      </div>
    </section>;
}